import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { handlers } from '../../helpers/helpers';
import { revisionService } from '../../services/revisionPage';

const CheckAnswers = ({
  group,
  groupCount,
  setGroupCount,
  setEditAnswerData,
  setScrollPosition,
  setStep,
  userData,
  groupsLength,
  refreshTestName,
  refreshTimer,
  refreshInitialTimeStamp,
  countryCode,
  timedSurveys,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [finalEvaluation, setFinalEvaluation] = useState(false);
  const [isSendFormError, setIsSendFormError] = useState(false);
  const [retryTimes, setRetryTimes] = useState(0);

  const isTimedSurvey = group[0]?.survey_code in timedSurveys;

  const checkIfFinalizeEvaluation = () => {
    const currentTestId = userData.testId;
    const testsLength = userData.tests.length - 1;
    const findCurrentTestIndex = userData.tests.findIndex(test => test.id === currentTestId);

    if (groupCount === groupsLength - 1) {
      if (findCurrentTestIndex < testsLength) {
        setFinalEvaluation(false);
      } else {
        setFinalEvaluation(true);
      }
    }
  };

  const handleNextGroup = async () => {
    const currentTestId = userData.testId;
    const testsLength = userData.tests.length - 1;
    const findCurrentTestIndex = userData.tests.findIndex(test => test.id === currentTestId);
    const countTestOfTestPage = userData.countTest;
    const isBattery = currentTestId.includes('_battery');

    if (groupCount === groupsLength - 1) {
      if (findCurrentTestIndex < testsLength) {
        handlers.handleUserData({
          countQuestion: 0,
          countGroup: 0,
          countTest: countTestOfTestPage + 1,
          currentRevisionGroup: 0,
          currentTestName: null,
          isTimerOn: false,
          editAnswerData: null,
          questionDataToEdit: null,
        })
        handlers.handleCurrentStep("currentTestStep", 1);
        handlers.handleCurrentStep("currentRevisionStep", 1);
        refreshTestName();
        refreshTimer();
        navigate(`/examenes/psicologia/${countryCode}/test`);
      }
    } else {
      setGroupCount(groupCount + 1);
    }
    if (group.length >= 1 && group[0].admissionPatientExam) {
      const admissionPatientExamId = group[0].admissionPatientExam;
      const currentTest = userData.tests[findCurrentTestIndex];
      await handlers.checkAndMarkSurveyAsPending({
        isBattery,
        currentExamId: admissionPatientExamId,
        test: currentTest,
        testsResults: userData.testsResults
      });
    }
  };

  const goToEdit = (answer) => {
    setEditAnswerData(answer);
    handlers.handleUserData({ editAnswerData: answer })
    setScrollPosition(window.pageYOffset);
    setStep(3);
  };

  const handleFinalizeEvaluation = async () => {
    setLoading(true);
    const currentDateTime = new Date();
    const getFinalTime = currentDateTime.toLocaleTimeString('es-CL');

    handlers.handleUserData({
      finalTestTime: getFinalTime,
      currentTestName: null,
      isTimerOn: false,
    });

    const data = {
      document_number: userData.document_number,
      document_type: userData.document_type,
      email: userData.email,
      educational_lvl: userData.education,
      drivers_license: userData.driversLicense,
      valid_driver_license: userData.controlDate,
      uses_glasses: userData.usesGlasses,
      tests_results: userData.testsResults,
    };
    try {
      const response = await revisionService.sendPatientForm(data, countryCode);
      if (response === 1) {
        refreshTestName();
        refreshTimer();
        handlers.handleUserData({
          isSendFormError: false
        });
        navigate(`/examenes/psicologia/${countryCode}/success`);
      } else {
        setIsSendFormError(true);
        setRetryTimes(retryTimes + 1);
        setLoading(false);
      }
    } catch (err) {
      console.error('Error Interno.', err);
      setIsSendFormError(true);
      setRetryTimes(retryTimes + 1);
      setLoading(false);
    }
  };

  useEffect(() => {
    checkIfFinalizeEvaluation();
  }, [group]);

  return (
    <Row justify="center" className="check-answers-container mt-30">
      <Col lg={22} md={22}>
        <h1 className="mb-20">Revisa tus respuestas</h1>
      </Col>
      <Col lg={22} md={22}>
        <Row justify="center">
          <Col md={24}>
            <p className="group-title mb-20">{group[0].groupName}</p>
          </Col>
          <Col md={24}>
            {
              group.map((answer, index) => {
                return (
                  <Row key={index} className="answer-gray-row p-20 mb-20">
                    <Col md={22} style={{ display: 'flex', alignItems: 'center' }}>
                      {
                        <Row justify="start">
                          {
                            answer.questionTitle &&
                            <Col md={24} style={{ display: 'flex', alignItems: 'center' }}>
                              <p className="answer-question mb-0" dangerouslySetInnerHTML={{ __html: answer.questionTitle }} />
                            </Col>
                          }
                          <Col md={24} style={{ display: 'flex', alignItems: 'center' }}>
                            <p className={answer.questionTitle ? "answer-text mb-0" : "answer-text-no-title mb-0"}>{
                              answer.answer
                            }</p>
                          </Col>
                        </Row>
                      }
                    </Col>
                    {!isTimedSurvey &&
                      <Col md={1} style={{ display: 'flex', alignItems: 'center' }}>
                          <Button
                            onClick={() => goToEdit(answer)}
                            className="edit-answer-button"
                            size="small"
                          >
                            EDITAR
                          </Button>
                      </Col>
                    }
                  </Row>
                )
              })
            }
          </Col>
        </Row>
      </Col>
      <Col lg={22} md={22} className="mt-50 mb-50">
        <Row justify="end">
          {
            !finalEvaluation ?
              <Col md={5}>
                <Button onClick={handleNextGroup} type="primary" size="large" block>Continuar</Button>
              </Col>
              :
              <Col md={24}>
                <Row justify="end">
                  {
                    !isSendFormError && retryTimes < 1 ?
                      <Col md={7}>
                        <Button loading={loading} onClick={handleFinalizeEvaluation} type="primary" size="large" block>Finalizar evaluación</Button>
                      </Col>
                      :
                      <Col md={9}>
                        <Button loading={loading} onClick={handleFinalizeEvaluation} type="primary" size="large" block>Reintentar finalizar evaluación</Button>
                      </Col>
                  }
                </Row>
              </Col>
          }
        </Row>
      </Col>
    </Row>
  );
};

export default CheckAnswers;